/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Napište něco…',
  'fabric.editor.editorAssistiveLabel': 'Hlavní oblast obsahu. Začněte psát, abyste zadali text.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Otevřít dialog nápovědy',
};
